module.exports = __webpack_public_path__ + "img/xhs_logo.fa6aa373.png";